import { Twitter as r } from "./twitter.js";
import { Facebook as m } from "./facebook.js";
import { Linkedin as o } from "./linkedin.js";
import { Andriod as i } from "./andriod.js";
import { Apple as e } from "./apple.js";
import { Instagram as t } from "./instagram.js";
import { Github as p } from "./github.js";
import { StackOverflow as f } from "./stack-overflow.js";
import { NumberOneCircleFilled as l } from "./number-one-circle-filled.js";
import { NumberTwoCircleFilled as d } from "./number-two-circle-filled.js";
import { NumberThreeCircleFilled as c } from "./number-three-circle-filled.js";
import { NumberFourCircleFilled as u } from "./number-four-circle-filled.js";
import { NumberFiveCircleFilled as b } from "./number-five-circle-filled.js";
import { NumberSixCircleFilled as g } from "./number-six-circle-filled.js";
import { NumberSevenCircleFilled as N } from "./number-seven-circle-filled.js";
import { NumberEightCircleFilled as S } from "./number-eight-circle-filled.js";
import { NumberNineCircleFilled as C } from "./number-nine-circle-filled.js";
import { Sdg1 as F } from "./sdg-1.js";
import { Sdg2 as n } from "./sdg-2.js";
import { Sdg3 as a } from "./sdg-3.js";
import { Sdg4 as w } from "./sdg-4.js";
import { Sdg5 as k } from "./sdg-5.js";
import { Sdg6 as v } from "./sdg-6.js";
import { Sdg7 as L } from "./sdg-7.js";
import { Sdg8 as O } from "./sdg-8.js";
import { Sdg9 as T } from "./sdg-9.js";
import { Sdg10 as h } from "./sdg-10.js";
import { Sdg11 as x } from "./sdg-11.js";
import { Sdg12 as A } from "./sdg-12.js";
import { Sdg13 as s } from "./sdg-13.js";
import { Sdg14 as E } from "./sdg-14.js";
import { Sdg15 as G } from "./sdg-15.js";
import { Sdg16 as I } from "./sdg-16.js";
import { Sdg17 as X } from "./sdg-17.js";
import { AppleLogoOutline as j } from "./apple-logo-outline.js";
import { Number1Circle as q } from "./number-1-circle.js";
import { Number1CircleFilled as y } from "./number-1-circle-filled.js";
import { Number2Circle as z } from "./number-2-circle.js";
import { Number3Circle as B } from "./number-3-circle.js";
import { Number4Circle as D } from "./number-4-circle.js";
import { Number5Circle as H } from "./number-5-circle.js";
import { Number6Circle as J } from "./number-6-circle.js";
import { Number7Circle as K } from "./number-7-circle.js";
import { Number7CircleFilled as M } from "./number-7-circle-filled.js";
import { Number8Circle as P } from "./number-8-circle.js";
import { Number9Circle as Q } from "./number-9-circle.js";
import { StackOverflowLogo as R } from "./stack-overflow-logo.js";
import { TwitterXLogo as U } from "./twitter-x-logo.js";
const Kr = {
  Twitter: r,
  Facebook: m,
  Linkedin: o,
  Andriod: i,
  Apple: e,
  Instagram: t,
  Github: p,
  StackOverflow: f,
  NumberOneCircleFilled: l,
  NumberTwoCircleFilled: d,
  NumberThreeCircleFilled: c,
  NumberFourCircleFilled: u,
  NumberFiveCircleFilled: b,
  NumberSixCircleFilled: g,
  NumberSevenCircleFilled: N,
  NumberEightCircleFilled: S,
  NumberNineCircleFilled: C,
  Sdg1: F,
  Sdg2: n,
  Sdg3: a,
  Sdg4: w,
  Sdg5: k,
  Sdg6: v,
  Sdg7: L,
  Sdg8: O,
  Sdg9: T,
  Sdg10: h,
  Sdg11: x,
  Sdg12: A,
  Sdg13: s,
  Sdg14: E,
  Sdg15: G,
  Sdg16: I,
  Sdg17: X,
  AppleLogoOutline: j,
  Number1Circle: q,
  Number1CircleFilled: y,
  Number2Circle: z,
  Number3Circle: B,
  Number4Circle: D,
  Number5Circle: H,
  Number6Circle: J,
  Number7Circle: K,
  Number7CircleFilled: M,
  Number8Circle: P,
  Number9Circle: Q,
  StackOverflowLogo: R,
  TwitterXLogo: U
};
export {
  Kr as Extra48
};
